<template>
  <div>
    <el-dialog
      @close="handleClose"
      :visible.sync="show"
      :close-on-click-modal="false"
      :append-to-body="true"
      :center="true"
      custom-class="login-dialog"
      width="530px"
    >
      <div slot="title" class="title">
        <span :class="{ active : isPhoneLogin }" @click="toggleLogin(LoginType.PhoneNum)">{{ $t("account.phoneNumLogin") }}</span>
        <span @click="handleQQlogin">QQ</span>
      </div>

      <!-- 手机号登录 -->
      <div v-if="isPhoneLogin" class="box phone-box">
        <el-form class="form" ref="form" :model="form" :rules="rules">
          <el-form-item prop="phoneNum">
            <el-input
              size="medium"
              v-model="form.phoneNum"
              :placeholder="$t('account.phoneNumPlaceholder')"
            >
            </el-input>
          </el-form-item>

          <el-form-item prop="code">
            <el-input
              size="medium"
              v-model="form.code"
              :placeholder="$t('account.codePlaceholder')"
              @keyup.native.enter="handleSubmit"
              :style="{ width: 'calc(100% - 124px)', marginRight: '12px' }"
            >
            </el-input>
            <el-button
              size="medium"
              type="primary"
              class="send-code-btn"
              :disabled="hasSend"
              @click="handleSendCode"
            >
              {{ sendCodeBtnText }}
            </el-button>
          </el-form-item>
        </el-form>

        <el-button
          type="primary"
          size="medium"
          class="login-btn"
          :loading="loading"
          @click="handleSubmit"
        >
          {{ $t("account.login") }}
        </el-button>

        <p class="err-msg" v-if="errMsg">
          {{ errMsg }}
        </p>

        <div class="agreement-wrapper">
          登录即表明您同意我们的
          <el-button type="text" @click="handleShowUserAgreement">用户协议</el-button>
          和<el-button type="text" @click="handleShowPrivacy">隐私政策</el-button>
        </div>

        <p class="phone-tip">未注册过的手机号，我们将自动帮您注册账号</p>
      </div>
    </el-dialog>

    <!-- 用户协议和隐私政策的展示弹窗 -->
    <el-dialog
      title=""
      custom-class="preview-dialog"
      :visible.sync="showAgree"
      width="40%"
      top="10vh"
      :center="true"
      :close-on-click-modal="false"
      destroy-on-close
      append-to-body
      fullscreen
      @close="handleAgreeClose"
    >
      <section style="padding: 0 10px;">
        <cherry-markdown
          v-if="markdownMap[showAgreeType]"
          class="markdown"
          markdown-id="register-markdown"
          :content="markdownMap[showAgreeType]"
          readonly
        ></cherry-markdown>
      </section>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { toLoginNew, getUrlParams, loginByQQNew } from '@/utils/auth'
import { getErrorCode, getDefaultErrorText } from '@/views/login/mixin'
import CherryMarkdown from '@/components/CherryMarkdown'

const LoginType = {
  PhoneNum: 'phoneNum',
  QQ_MP: 'qq_mp',
}

export default {
  name: 'NewLoginDialog',
  components: {
    CherryMarkdown
  },

  data() {
    return {
      LoginType,

      errMsg: '',
      show: false,
      loading: false,
      rules: {
        phoneNum: [
          {
            required: true,
            message: this.$t('account.phoneNumPlaceholder'),
            trigger: 'blur',
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t('account.phoneNumError'),
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: this.$t('account.codePlaceholder'),
            trigger: 'blur',
          },
          {
            pattern: /^\d{6}$/,
            message: this.$t('account.codeError'),
            trigger: 'blur',
          },
        ],
      },
      form: {
        phoneNum: '',
        code: '',
      },

      loginType: LoginType.PhoneNum,
      hasSend: false,
      sendCnt: 0,
      count: 60,
      showAgree: false,
      showAgreeType: 'agreement',
    }
  },

  computed: {
    ...mapGetters(['markdownMap', 'markdownVersionMap']),
    isPhoneLogin() {
      return this.loginType === LoginType.PhoneNum
    },
    sendCodeBtnText() {
      return this.hasSend ? `${this.count}s` : this.sendCnt > 0 ? this.$t('account.reSend') : this.$t('account.sendCode')
    },
  },

  async created() {
    const { code, path, redirect_type: redirectType } = getUrlParams()
    if (code && redirectType === 'ai_login') {
      await loginByQQNew({ code, loginType: 2 }) // 1 wx 2qq
      history.replaceState(null, '', `${location.origin}${path}`)
      this.afterLogin()
    }
  },

  destroyed() {
    this.destoryQm && this.destoryQm.destroy()
  },

  methods: {
    open() {
      this.show = true
    },

    handleClose() {
      this.$store.commit('login', false)
      this.$refs.form && this.$refs.form.resetFields()
      this.show = false
    },

    toggleLogin(type) {
      this.loginType = type
      this.$refs.form && this.$refs.form.resetFields()
    },

    handleQQlogin() {
      this.handleClose()
      toLoginNew('ai_login')
    },

    // 回调不通，后续有接入需求再跟Q音联调
    handleQQMPLogin() {
      this.handleClose()
      const { origin, pathname } = window.location
      const redirectUri = `${origin}?path=${pathname}`
      this.destoryQm = window.QmfeLoginOauth.openLoginDialog({
        loginOpts: {
          QQCustomParameter: {
            response_type: 'code',
            client_id: '102107968', // 申请QQ登录成功后，分配给应用的appid
            redirect_uri: redirectUri, // 成功授权后的回调地址，必须是注册appid时填写的主域名下的地址
            state: 'tmecp', // client端的状态值。用于第三方应用防止CSRF攻击，成功授权后回调时会原样带回。请务必严格按照流程检查用户与state参数状态的绑定。
            // display: string, // 用于展示的样式。不传则默认展示为PC下的样式。如果传入mobile，则展示为mobile端下的样式
            // scope: string, // 打开QQ好友关系配置权限
            // 可传入自定义值，会浅合并
          },
          // WXCustomParameter:{
          //     appid: string, // 应用唯一标识
          //     redirect_uri: string, // 请使用urlEncode对链接进行处理
          //     response_type: string,
          //     scope: string, // 应用授权作用域，拥有多个作用域用逗号（,）分隔，网页应用目前仅填写snsapi_login即
          //     state: string,
          //     href: string,
          //     ...  // 可传入自定义值，会浅合并
          // },
          // WXLoginBaseUrl : string; // 外部自定义vx登陆url
          // QQLoginBaseUrl : string; // 外部自定义qq登陆url
        }
      })
    },

    handleShowUserAgreement() {
      this.showAgreeType = 'agreement'
      this.showAgree = true
    },
    handleShowPrivacy() {
      this.showAgreeType = 'privacy'
      this.showAgree = true
    },

    handleAgreeClose() {
      this.showAgree = false
    },

    // 验证表单字段promise化
    validateField(field) {
      return new Promise((resolve, reject) => {
        this.$refs.form.validateField(field, (err) => {
          if (err) {
            reject(err)
          } else {
            resolve()
          }
        })
      })
    },

    async handleSendCode() {
      try {
        await this.validateField('phoneNum')
      } catch (error) {
        return
      }

      // 发送验证码
      try {
        const { code } = await this.$store.dispatch('SendCode', this.form.phoneNum)
        if (code === 200) {
          this.hasSend = true
          this.sendCnt++
          this.count = 60
          const timer = setInterval(() => {
            this.count--
            if (this.count <= 0) {
              clearInterval(timer)
              this.hasSend = false
            }
          }, 1000)
        } else {
          this.errMsg = getErrorCode()[code]
        }
      } catch (error) {
        console.error(error)
        this.errMsg = getDefaultErrorText()
      }
    },

    handlePhoneLogin() {
      return this.$store.dispatch('LoginPhone', {
        phoneNum: this.form.phoneNum,
        code: this.form.code,
        version: this.markdownVersionMap.agreement // 只取用户协议的版本号
      })
    },

    async handleSubmit() {
      try {
        await this.$refs.form.validate()
      } catch (e) {
        return
      }
      this.errMsg = ''
      this.loading = true

      try {
        const { code } = await this.handlePhoneLogin()
        if (code === 200) {
          this.afterLogin()
        } else {
          this.errMsg = getErrorCode()[code]
        }
      } catch (e) {
        console.error(e)
        this.errMsg = getDefaultErrorText()
      }
      this.loading = false
    },

    afterLogin() {
      this.handleClose()
      this.$store.dispatch('GetNotice')
      this.$store.dispatch('GetInfo')
    }
  },
}
</script>

<style lang="scss">
.login-dialog {
  .el-dialog__header {
    padding-bottom: 0px;
  }
  .el-form-item__error {
    margin-left: 60px;
  }

  .box {
    width: 350px;
    margin: 20px auto 10px;

    &.phone-box {
      ::v-deep {
        .el-form-item__error {
          margin-left: 0px;
        }
      }
    }
  }

  .title {
    margin-top: 20px;

    span {
      margin: 0 40px;
      display: inline-block;
      font-size: 15px;
      font-weight: bold;
      cursor: pointer;

      &:hover {
        color: #409eff;
      }

      &.active {
        color: #409eff;
        &::after {
          margin: 10px auto -2px;
          display: block;
          content: "";
          width: 20px;
          height: 3px;
          border-radius: 1px;
          background-color: #409eff;
        }
      }
    }
  }

  .err-msg {
    margin-top: 6px;
    font-size: 12px;
    color: #f56c6c;
    text-align: center;
  }

  .agreement-wrapper {
    text-align: center;
    font-size: 13px;
    color: #666;
    font-weight: bold;

    /deep/ .el-button + .el-button {
      margin-left: 5px;
    }
  }

  .phone-tip {
    font-size: 12px;
    color: #909399;
    text-align: center;
  }

  .send-code-btn {
    min-width: 112px;
  }

  .login-btn {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
  }
}
</style>
